import React, { useEffect } from 'react';
import styles from './agendamento_marjorie_lashdesign.module.scss';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import perfilAgendamento from './src/perfil-agendamento.png';

const WHATSAPP_NUMBER = '5564993010303';

const Agendamento_marjorie_lashdesign: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const openWhatsApp = () => {
        window.open(`https://wa.me/${WHATSAPP_NUMBER}`, '_blank');
    };

    return (
        <div className={styles.pageWrapper}>
            <div className={styles.agendamento_marjorie_lashdesign}>
                <div className={styles.header}>
                    <Link to="/marjorie_lashdesign" className={styles.backButton} aria-label="Voltar">
                        <FaArrowLeft />
                    </Link>
                    <h2>Agendamento</h2>
                </div>

                <div className={styles.profile}>
                    <h1 className={styles.nome}>Marjorie Lash Design</h1>
                    <img
                        src={perfilAgendamento}
                        alt="Marjorie Lash Design"
                        className={styles.foto}
                    />
                    <p className={styles.texto}>Faça seu agendamento</p>
                    <p className={styles.subtitulo}>
                        Reserve seu horário e tenha um atendimento personalizado, pensado para realçar a sua beleza natural.
                    </p>
                    <button type="button" className={styles.ctaButton} onClick={openWhatsApp}>
                        Quero agendar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Agendamento_marjorie_lashdesign;
